export default __webpack_public_path__ + "static/saemi.park.changwon.lee-321b2caa94b0695e3c9c883ec90f8729.png";